<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style lang="less">
@import "@/assets/styles/normalize.css";
@import "@/assets/styles/base.less";
@import "@/assets/styles/universal.less";

.el-row {
  height: 100%;
}


.el-dropdown-link {
  cursor: pointer;
}

/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width: 10px;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  .background-main-1();

  border-radius: 10px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 50%;
}
#app {
  height: 100%;
}

</style>
